'use strict';
var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/validate-arguments-length.js
// module id = 87
// module chunks = 0